const RECEIVE_ALL_OMNI_CATEGORIES = 'src/omniBrands/RECEIVE_ALL_OMNI_CATEGORIES' as const;

export default { RECEIVE_ALL_OMNI_CATEGORIES };
